
import { TextComponent } from '../textcomponent';
import { UIComponentHandler, UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { MsisdnTextViewImpl } from './msisdntextview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { MsisdnTextCSSStyleImpl } from './msisdntextcss';
import { BaseContext } from '../../../../utils/basecontext';



export class MsisdnTextComponent extends TextComponent
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MsisdnTextViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MsisdnTextCSSStyleImpl(applicationContext);
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/msisdntext/msisdntextcomponent.tsx